// Портал горим: "teacher" (багшийн layout), "counselor" (зөвлөхийн layout) эсвэл "admin".
// Ганц портал → шууд тэр. Хэд хэдэн (багш + удирдлага, зөвлөх + удирдлага г.м.) → нэвтэрсний дараа сонгоно (/choose), сонголтыг хөтөч санана.
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useAccess } from "contexts/access";

const TEACHER_KEYS = ["teacher", "homeroom", "elementary", "house"];
const COUNSELOR_KEYS = ["counselor"];
const KEY = "portalMode";
const read = () => { try { return localStorage.getItem(KEY); } catch (e) { return null; } };

// Портал бүрийн нүүр
export const PORTAL_HOME = { teacher: "/t", counselor: "/c", admin: "/" };

const PortalContext = React.createContext({ loading: true, mode: null, portals: [], dual: false, isTeacher: false, choose: () => {} });

export function PortalProvider({ children }) {
  const { roles, isSuper, loading, setScope, adminModules } = useAccess();
  const [chosen, setChosen] = useState(read);
  const choose = useCallback((m) => { try { localStorage.setItem(KEY, m); } catch (e) { /* зөвхөн энэ удаад */ } setChosen(m); }, []);
  const value = useMemo(() => {
    const isTeacher = roles.some((r) => TEACHER_KEYS.includes(r.key));
    const isCounselor = roles.some((r) => COUNSELOR_KEYS.includes(r.key));
    // Удирдлагын роль, эсвэл багшид нэмэлтээр өгсөн удирдлагын эрх (жишээ нь Passion Program засах)
    const hasOther = isSuper || roles.some((r) => !TEACHER_KEYS.includes(r.key) && !COUNSELOR_KEYS.includes(r.key)) || (adminModules || []).length > 0;
    const portals = [isTeacher && "teacher", isCounselor && "counselor", (hasOther || (!isTeacher && !isCounselor)) && "admin"].filter(Boolean);
    const mode = loading ? null : portals.length === 1 ? portals[0] : portals.includes(chosen) ? chosen : null;
    return { loading, mode, portals, dual: portals.length > 1, isTeacher, isCounselor, choose };
  }, [roles, isSuper, loading, chosen, choose, adminModules]);
  // Удирдлагын горимд эрхийг зөвхөн backoffice рольоор
  useEffect(() => { setScope?.(value.mode === "admin" ? "admin" : null); }, [value.mode, setScope]);
  return <PortalContext.Provider value={value}>{children}</PortalContext.Provider>;
}

export const usePortal = () => useContext(PortalContext);

// Нэрийн цэсэнд: олон рольтой хүнд "Ажиллах горим солих" — эхний сонголтын хуудас (/choose) руу (antd Dropdown items)
export const switchItems = (portal, navigate) => (portal.dual ? [{ key: "switch", label: "Ажиллах горим солих", onClick: () => navigate("/choose") }] : []);

// Гарах үед сонголтыг цэвэрлэнэ (дараагийн нэвтрэлтэд дахин асууна)
export const clearPortalMode = () => { try { localStorage.removeItem(KEY); } catch (e) { /* noop */ } };
